import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { TaskWorkflowByProfile } from "../../core/model/task-workflow-by-profile";
import { Workflow } from "../../core/model/workflow";
import { UserProfile } from "../../core/model/user-profile";
import { ServiceTask } from "../../core/model/serviceTask";
import { Formulaire } from "../../core/model/formulaire";
import { WorkflowService } from "../../core/service/workflow.service";
import { UserProfileService } from "../../core/service/user-profile.service";
import { TaskWorkflowByProfileService } from "../../core/service/task-workflow-by-profile.service";
import { FormulaireService } from "../../core/service/formulaire.service";
import { ServiceService } from "../../core/service/service.service";

@Component({
  selector: "app-add-task",
  templateUrl: "./add-task.component.html",
  styleUrls: ["./add-task.component.scss"],
})
export class AddTaskComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  task: TaskWorkflowByProfile = new TaskWorkflowByProfile();
  workflows: Workflow[];
  profiles: UserProfile[];
  services: ServiceTask[];
  formulaires: Formulaire[];

  constructor(
    private _router: Router,
    private _workflowService: WorkflowService,
    private _userProfileService: UserProfileService,
    private _taskWorkflowByProfileService: TaskWorkflowByProfileService,
    private _formulaireService: FormulaireService,
    private _serviceService: ServiceService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      taskKey: [null, Validators.compose([Validators.required])],
      taskName: [null, Validators.compose([Validators.required])],
      type: [null],
      workflow: [null, Validators.compose([Validators.required])],
      userProfile: [null, Validators.compose([Validators.required])],
      service: [null, Validators.compose([Validators.required])],
      formulaire: [null, Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {
    this.getWorkflows();
    this.getUserProfiles();
    this.getAllServices();
    this.getAllFormulaires();
  }

  getWorkflows() {
    this._workflowService.getAllWorkflows().subscribe(
      (data) => {
        this.workflows = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUserProfiles() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.profiles = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllServices() {
    this._serviceService.getAllServices().subscribe(
      (data) => {
        this.services = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllFormulaires() {
    this._formulaireService.getAllFormulaires().subscribe(
      (data) => {
        this.formulaires = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this._taskWorkflowByProfileService
      .add(this.task)
      .pipe(first())
      .subscribe(
        (data) => {
          this.goToList();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/task");
  }
}
